__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "multi-tenant-platform";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@radix-ui/react-alert-dialog", "1.1.15", () => (() => (__webpack_require__(2610))), 1);
			register("@radix-ui/react-avatar", "1.1.11", () => (() => (__webpack_require__(4439))), 1);
			register("@radix-ui/react-checkbox", "1.3.3", () => (() => (__webpack_require__(6622))), 1);
			register("@radix-ui/react-collapsible", "1.1.12", () => (() => (__webpack_require__(7885))), 1);
			register("@radix-ui/react-dialog", "1.1.15", () => (() => (__webpack_require__(5179))), 1);
			register("@radix-ui/react-dropdown-menu", "2.1.16", () => (() => (__webpack_require__(9878))), 1);
			register("@radix-ui/react-label", "2.1.8", () => (() => (__webpack_require__(5131))), 1);
			register("@radix-ui/react-popover", "1.1.15", () => (() => (__webpack_require__(9604))), 1);
			register("@radix-ui/react-scroll-area", "1.2.10", () => (() => (__webpack_require__(8100))), 1);
			register("@radix-ui/react-select", "2.2.6", () => (() => (__webpack_require__(1479))), 1);
			register("@radix-ui/react-separator", "1.1.8", () => (() => (__webpack_require__(6208))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(9204))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(5485))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(4473))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(3978))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(2506))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(6590))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(3357))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(8088))), 1);
			register("@radix-ui/react-slot", "1.2.4", () => (() => (__webpack_require__(6851))), 1);
			register("@radix-ui/react-switch", "1.2.6", () => (() => (__webpack_require__(7943))), 1);
			register("@radix-ui/react-tabs", "1.1.13", () => (() => (__webpack_require__(7127))), 1);
			register("@radix-ui/react-tooltip", "1.2.8", () => (() => (__webpack_require__(8126))), 1);
			register("axios", "1.13.2", () => (() => (__webpack_require__(182))), 1);
			register("class-variance-authority", "0.7.1", () => (() => (__webpack_require__(917))), 1);
			register("clsx", "2.1.1", () => (() => (__webpack_require__(8387))), 1);
			register("cmdk", "1.1.1", () => (() => (__webpack_require__(1307))), 1);
			register("date-fns", "4.1.0", () => (() => (__webpack_require__(2730))), 1);
			register("lucide-react", "0.562.0", () => (() => (__webpack_require__(2485))), 1);
			register("modern-screenshot", "4.6.8", () => (__webpack_require__.e(669).then(() => (() => (__webpack_require__(9669))))));
			register("next-themes", "0.4.6", () => (() => (__webpack_require__(205))), 1);
			register("react-day-picker", "9.13.0", () => (() => (__webpack_require__(2430))), 1);
			register("react-dom", "19.2.3", () => (() => (__webpack_require__(7950))), 1);
			register("react-markdown", "10.1.0", () => (() => (__webpack_require__(3713))), 1);
			register("react-router-dom", "6.30.2", () => (() => (__webpack_require__(3245))), 1);
			register("react", "19.2.3", () => (() => (__webpack_require__(5043))), 1);
			register("socket.io-client", "4.8.3", () => (() => (__webpack_require__(2104))), 1);
			register("sonner", "2.0.7", () => (() => (__webpack_require__(6328))), 1);
			register("tailwind-merge", "3.4.0", () => (() => (__webpack_require__(9359))), 1);
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};